
import {
    SET_APP_THEME,
    SET_MODAL_CHILDREN,
    SET_SHOW_POPUP,
 } from "../actionTypes/app.actionType"
import { DispatchType, TogglePopupType } from "../types"

export function setAppTheme(data: string){
    return (dispatch: DispatchType) => {
        dispatch({
            type: SET_APP_THEME,
            data,
        })
    }
}

export function togglePopup(data: TogglePopupType) {
  return (dispatch: DispatchType) => {
    dispatch({ type: SET_SHOW_POPUP, data });
  };
}

export function setPopupChildren(data: JSX.Element, onDismiss: (() => void )) {
  return (dispatch: DispatchType) => {
    dispatch({
      type: SET_MODAL_CHILDREN,
      data,
      onDismiss: onDismiss || (() => { }),
    });
  };
}
